import prefersReducedMotion from '../services/utilities';

class NumberScaleUp {
    numberNodes = null;

    constructor() {
        this.numberNodes = jQuery('.scale-up-number');

        if (prefersReducedMotion) {
            // eslint-disable-next-line
            this.numberNodes.each((index, numberNode) => numberNode.innerText = numberNode.dataset.number);
        } else {
            this.init();
        }
    }

    init() {
        this.numberNodes.each((index, numberNode) => {
            NumberScaleUp.animate(numberNode);
        });
    }

    static animate(node) {
        const $node = jQuery(node);
        const countTo = $node.attr('data-number');
        let func = NumberScaleUp.getCurrentNumber;

        if ($node.hasClass('with-plus')) {
            func = NumberScaleUp.getCurrentNumberPoint;
        }

        jQuery({countNum: $node.text()}).animate(
            {
                countNum: countTo,
            },
            {
                duration: 4000,
                easing: 'linear',
                step: (countNum) => {
                    $node.text(func(countNum));
                },
            },
        );
    }

    static getCurrentNumberPoint(val) {
        let currentValue = val;

        currentValue = Math.floor(currentValue);

        if (currentValue > 999) {
            currentValue = String(currentValue);
            return `${currentValue.slice(0, -3)}.${currentValue.substring(-3, 3)}`;
        }
        return currentValue;
    }

    static getCurrentNumber(val) {
        return Math.floor(val);
    }
}

export default function initializeNumberScaleUp() {
    return new NumberScaleUp();
}
